module.exports = __webpack_public_path__ + "img/warning-big.37d93d81.svg";